export default __webpack_public_path__ + "static/media/Armband of Conflagrant Flame.70060f90.jpg";